import { render, staticRenderFns } from "./BootstrapLoader.vue?vue&type=template&id=180b41c5&scoped=true&"
import script from "./BootstrapLoader.vue?vue&type=script&lang=js&"
export * from "./BootstrapLoader.vue?vue&type=script&lang=js&"
import style0 from "./BootstrapLoader.vue?vue&type=style&index=0&id=180b41c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b41c5",
  null
  
)

export default component.exports